import { render, staticRenderFns } from "./extras-list.vue?vue&type=template&id=51cede34&scoped=true"
import script from "./extras-list.vue?vue&type=script&lang=js"
export * from "./extras-list.vue?vue&type=script&lang=js"
import style0 from "./extras-list.vue?vue&type=style&index=0&id=51cede34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cede34",
  null
  
)

export default component.exports